import i18n from "../../i18n";
const API_URL = process.env.REACT_APP_BUSINESS_SERVICE_BASE_URL || '';

export interface BusinessAdmin {
    /** "OWNER" (permanent) or "ADMIN" (a granted team member). */
    type: string;
    /** team_member id — null for OWNER. */
    teamMemberId?: string | null;
    /** user-service user id of the owner — null for ADMIN. */
    userId?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    /** False for OWNER (permanent); true for grantable team-member admins. */
    removable: boolean;
}

async function gqlPost<T>(token: string, query: string, variables?: object): Promise<T> {
    const res = await fetch(API_URL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`, "Accept-Language": i18n.language || "pt",
        },
        body: JSON.stringify({ query, variables }),
    });
    const json = await res.json();
    if (json.errors) {
        const msg = json.errors.map((e: { message: string }) => e.message).join(', ');
        throw new Error(msg);
    }
    return json.data as T;
}

const ADMIN_FIELDS = `
    type
    teamMemberId
    userId
    firstName
    lastName
    email
    removable
`;

export async function getBusinessAdmins(
    businessId: number | string,
    token: string
): Promise<BusinessAdmin[]> {
    const data = await gqlPost<{ businessAdmins: BusinessAdmin[] | null }>(
        token,
        `query businessAdmins($businessId: ID!) {
            businessAdmins(businessId: $businessId) { ${ADMIN_FIELDS} }
        }`,
        { businessId }
    );
    return data.businessAdmins ?? [];
}

export async function grantTeamMemberAdmin(
    businessId: number | string,
    teamMemberId: number | string,
    token: string
): Promise<boolean> {
    const data = await gqlPost<{ grantTeamMemberAdmin: boolean }>(
        token,
        `mutation grantTeamMemberAdmin($businessId: ID!, $teamMemberId: ID!) {
            grantTeamMemberAdmin(businessId: $businessId, teamMemberId: $teamMemberId)
        }`,
        { businessId, teamMemberId }
    );
    return !!data.grantTeamMemberAdmin;
}

export async function revokeTeamMemberAdmin(
    businessId: number | string,
    teamMemberId: number | string,
    token: string
): Promise<boolean> {
    const data = await gqlPost<{ revokeTeamMemberAdmin: boolean }>(
        token,
        `mutation revokeTeamMemberAdmin($businessId: ID!, $teamMemberId: ID!) {
            revokeTeamMemberAdmin(businessId: $businessId, teamMemberId: $teamMemberId)
        }`,
        { businessId, teamMemberId }
    );
    return !!data.revokeTeamMemberAdmin;
}
